// TODO CSCART4 - Integrate this into the 'ToggleContent' class?
/**
 * Toggle and activate a tab from a link.
 *
 * @property {HTMLCollectionOf<Element>} links activate and display the tab.
 * @property {HTMLCollectionOf<Element>} tabs will activate when their corresponding link is clicked.
 */
export class ToggleTabLink {
    links: HTMLCollectionOf<HTMLElement>;
    tabs: HTMLCollectionOf<HTMLElement>;

    /**
     * Toggle and activate a tab from a link.
     *
     * @param {HTMLCollectionOf<Element>} links activate and display the tab.
     * @param {HTMLCollectionOf<Element>} tabs will activate when their corresponding link is clicked.
     */
    constructor(links: HTMLCollectionOf<HTMLElement>, tabs: HTMLCollectionOf<HTMLElement>) {
        this.links = links;
        this.tabs = tabs;

        this.bind();
    }

    /**
     * Bind the elements to a click event.
     *
     * @returns {void}
     */
    bind() : void {
        for (const link of this.links) {
            link.addEventListener('click', this.toggle_tab.bind(this), false);
        }
    }

    /**
     * Handles the display of the selected tab.
     *
     * @param {Event} event The element that was clicked to display the tab.
     * @returns {void}
     */
    toggle_tab(event: Event) {
        event.preventDefault();
        for (const tab of this.tabs) {
            tab.classList.remove('active');
            if ((event.currentTarget as HTMLElement).dataset.tabId === tab.dataset.id) {
                tab.click();
                tab.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        }
    }
}